import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";


class StaffForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      gender: [],
      faculty: [],
      department: [],
      entry_year: [],
      sections: [],
      positions: [],
    },
    data: {
      staff_name: "",
      staff_name_en: "",
      staff_lastname: "",
      staff_lastname_en: "",
      staff_phone: "",
      staff_email: "",
      staff_dob: "",
      staff_photo: "",
      gender: "",
      position: "",
      section: "",
      faculty: null,
      department: null,
      start_time: "",
      end_time: "",
    },
    errors: {},
  };

  convertTo24Hour = (time_12) => {
    const [time, modifier] = time_12.split(' ');
    let [hours, minutes] = time.split(':');

    if (hours === '12') hours = '00';

    if (modifier === 'PM') hours = parseInt(hours, 10) + 12;

    return `${hours}:${minutes}`;
  }

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const {
      popUp: { cache, edit },
    } = this.context;

    if (edit) {
        data.staff_name = edit.first_name;
        data.staff_name_en = edit.first_name_en;
        data.staff_lastname = edit.last_name;
        data.staff_lastname_en = edit.last_name_en;
        data.staff_phone = edit.staff_phone;
        data.staff_email = edit.staff_email;
        data.staff_dob = edit.staff_dob;
        data.staff_photo = edit.staff_photo;
        data.gender = edit.gender_id;
        data.position = edit.position_id;
        data.section = edit.section_id;
        data.faculty = edit.faculty_id;
        data.department = edit.department_id;
        data.start_time = this.convertTo24Hour(edit.start_time);
        data.end_time = this.convertTo24Hour(edit.end_time);
    }



    await db
      .getAll(`dropdowns/genders`)
      .then(({ data: { data } }) => (drp["gender"] = data));

    await db
      .getAll(`dropdowns/faculties`)
      .then(({ data: { data } }) => (drp["faculty"] = data));

    await db
        .getAll(`dropdowns/staffPositions`)
        .then(({ data: { data } }) => (drp["positions"] = data));

    await db
        .getAll(`dropdowns/staffSections`)
        .then(({ data: { data } }) => (drp["sections"] = data));

    if(data.faculty) {
      const faculty_id = data.faculty;
      await db
          .getAll(`dropdowns/departments`)
          .then(({ data: { data } }) => (drp["department"] =
              data.filter((department) => department.faculty === faculty_id)));
    }


    this.setState({ drp, data });
  };

  reloadDepartments = async (e) => {
    const { data, drp } = this.state;

    data.faculty = e.data.id
    const faculty_id = data.faculty;

    // reset old values
    data.department = null;
    drp.department = []

    await db
        .getAll(`dropdowns/departments`)
        .then(({ data: { data } }) => (drp["department"] = data.filter(
            (department) => department.faculty === faculty_id)
        ));

    this.setState({ data, drp });
  };


  schema = {
    staff_name: Joi.string().max(32),
    staff_name_en: Joi.string().max(32),
    staff_lastname: Joi.string().max(32),
    staff_lastname_en: Joi.string().max(32),
    staff_phone: Joi.string().max(14),
    staff_email: Joi.string().max(64),
    staff_dob: Joi.string(),
    staff_photo: Joi.string().max(256).allow(null).allow(''),
    gender: Joi.number(),
    position: Joi.number(),
    section: Joi.number(),
    faculty: Joi.number().allow(null).allow(''),
    department: Joi.number().allow(null).allow(''),
    start_time: Joi.string().regex(/^([0-9]{2})\:([0-9]{2})$/),
    end_time: Joi.string().regex(/^([0-9]{2})\:([0-9]{2})$/)
  };

  doSubmit = async (e) => {
    const { togglePopUp, popUp } = this.context;

    let __controls = this.cleanObject({
      staff_id: popUp?.cache,
      ...this.state.data,
    });

    try {
      await db
          .form("staff", e.target, __controls, popUp?.edit?.staff_id)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((e) => {
            togglePopUp({
              form: "toast",
              message: e.toString(),
              type: "warning",
            });
          });
      if (popUp.callback) popUp.callback();
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { data, drp } = this.state;
    const { popUp } = this.context;

      console.log(this.state.data)
      console.log(this.state.errors)

    return (
      <div className="form-container">
          <form className="form crud" onSubmit={this.handleSubmit}>
              <div className="head">
                  <p>{popUp?.edit ? lbl.EditStaff : lbl.AddStaff}</p>
              </div>
            <div className="form-inputs">
              {this.renderImg("staff_photo", data.staff_photo)}
              <div className="multi-input">
                {this.renderInput("staff_name", "اسم", "text")}
                {this.renderInput("staff_name_en", "Name", "text")}
              </div>
              <div className="multi-input">
                {this.renderInput("staff_lastname", "تخلص", "text")}
                {this.renderInput("staff_lastname_en", "Last name", "text")}
              </div>
              <div className="multi-input">
                {this.renderSelect("faculty", "پوهنحی", drp["faculty"], false, this.reloadDepartments)}
                {this.renderSelect("department", "دپارتمنت", drp["department"])}
              </div>
              <div className="multi-input">
                {this.renderSelect("section", "بخش", drp["sections"])}
                {this.renderSelect("position", "وظیفه", drp["positions"])}
              </div>
              <div className="multi-input">
                {this.renderSelect("gender", "جنسیت", drp["gender"])}
                {this.renderInput("staff_dob", "تاریخ تولد", "date")}
              </div>
              <div className="multi-input">
                {this.renderInput("staff_phone", "شماره تماس", "text")}
                {this.renderInput("staff_email", "ایمیل", "text")}
              </div>
              <div className="multi-input">
                {this.renderInput("start_time", "ساعت شروع", "time")}
                {this.renderInput("end_time", "ساعت ختم", "time")}
              </div>
            </div>
              <div className="form-buttons">
                  {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
              </div>
          </form>
      </div>
    );
  }
}

export default StaffForm;